import {
    BuildingOfficeIcon,
    CalendarDaysIcon,
    EnvelopeOpenIcon,
    HeartIcon,
    HomeIcon,
    MoonIcon,
    TagIcon,
} from "@heroicons/react/24/outline";
import { HandshakeIcon } from "components/ui/handshake-icon";
import React from "react";
import { WorkflowTriggerKind } from "./workflow-blueprint";

interface TriggerKindIconProps {
    kind: WorkflowTriggerKind;
    className: string;
}

export const TriggerKindIcon: React.FC<TriggerKindIconProps> = props => {
    const { kind, className } = props;
    switch (kind) {
        case "statusChange":
            return <TagIcon className={className} />;
        case "checkLater":
            return <CalendarDaysIcon className={className} />;
        case "moveIn":
            return <HomeIcon className={className} />;
        case "referralSourceChosen":
            return <HandshakeIcon className={className} />;
        case "communityChosen":
            return <BuildingOfficeIcon className={className} />;
        case "emailOpened":
            return <EnvelopeOpenIcon className={className} />;
        case "inactivity":
            return <MoonIcon className={className} />;
        case "careStart":
            return <HeartIcon className={className} />;
        case "addedToOrganization":
            return <BuildingOfficeIcon className={className} />;
        default: {
            const exhaustiveCheck: never = kind;
            console.warn(`Unhandled trigger kind: ${exhaustiveCheck}`);
            return null;
        }
    }
};
